import { cn } from '@/lib/utils';

interface ItemCardSkeletonProps {
  className?: string;
}

export const ItemCardSkeleton = ({ className }: ItemCardSkeletonProps) => {
  return (
    <div className={cn("w-full h-full relative rounded-md", className)}>
      {/* 文件图标区域 */}
      <div className="w-full h-[148px] relative rounded-md bg-gray-200 animate-pulse flex flex-col items-center justify-center ">
      </div>
      {/* 模拟文件名文本 */}
      <div className="w-full mt-3">
        <div className="w-3/4 h-4 mx-auto rounded bg-gray-200 animate-pulse"></div>
        <div className="w-2/3 h-4 mx-auto mt-1 rounded bg-gray-200 animate-pulse"></div>
      </div>
    </div>
  );
};

/** 批量知识库卡片骨架屏组件 */
export const ItemSkeletonList: React.FC<{ count?: number }> = ({
  count = 8,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ItemCardSkeleton key={index} />
      ))}
    </>
  );
};